// Tell jquery not to bind $ globally since prototype expects this variable
// not to be set.
$.noConflict();
